import { PureComponent } from "react";
import { string } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

class TextArea extends PureComponent {
  render() {
    const { size, ...rest } = this.props;
    return <Input {...rest} />;
  }
}

Text.propTypes = {
  height: string,
  size: string,
};

const Input = styled.textarea`
  background-clip: padding-box;
  background-color: ${({ theme }) => theme.text.backgroundColor};
  border: ${rem("1px")} solid ${({ theme }) => theme.text.borderColor};
  border-radius: ${rem("5px")};
  color: ${({ theme }) => theme.input.color};
  display: block;
  font-size: ${({ size, theme }) => {
    switch (size) {
      case "small":
        return rem("16px");
      default:
        return theme.input.fontSize;
    }
  }};
  height: ${({ height }) => {
    switch (height) {
      case "short":
        return rem("70px");
      default:
        return rem("140px");
    }
  }};
  max-width: 100%;
  padding: ${({ theme }) => theme.input.paddingY} ${rem("14px")};
  resize: vertical;
  width: 100%;

  &:focus {
    outline: ${rem("1px")} dotted;
    outline-offset: ${rem("2px")};
  }

  .has-error & {
    border-color: ${({ theme }) => theme.error.color};
  }
`;

export default TextArea;
